import React, { Component, MouseEvent } from 'react';
import './Game.css';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

let id_mapping = [
  {sound:new Audio("/wav/pied-gauche-vert.wav"), color: "#0F0", text:"Pied gauche, vert"},
  {sound:new Audio("/wav/pied-gauche-jaune.wav"), color: "yellow", text:"Pied gauche, jaune"},
  {sound:new Audio("/wav/pied-gauche-bleu.wav"), color: "#00F", text:"Pied gauche, bleu"},
  {sound:new Audio("/wav/pied-gauche-rouge.wav"), color: "#f00", text:"Pied gauche, rouge"},
  {sound:new Audio("/wav/pied-gauche-en-lair.wav"), color: "#FFF", text:"Pied gauche, en l’air"},
  {sound:new Audio("/wav/pied-droit-vert.wav"), color: "#0F0", text:"Pied droit, vert"},
  {sound:new Audio("/wav/pied-droit-jaune.wav"), color: "yellow", text:"Pied droit, jaune"},
  {sound:new Audio("/wav/pied-droit-bleu.wav"), color: "#00F", text:"Pied droit, bleu"},
  {sound:new Audio("/wav/pied-droit-rouge.wav"), color: "#f00", text:"Pied droit, rouge"},
  {sound:new Audio("/wav/pied-droit-en-lair.wav"), color: "#FFF", text:"Pied droit, en l’air"},
  {sound:new Audio("/wav/main-gauche-vert.wav"), color: "#0F0", text:"Main gauche, vert"},
  {sound:new Audio("/wav/main-gauche-jaune.wav"), color: "yellow", text:"Main gauche, jaune"},
  {sound:new Audio("/wav/main-gauche-bleu.wav"), color: "#00F", text:"Main gauche, bleu"},
  {sound:new Audio("/wav/main-gauche-rouge.wav"), color: "#f00", text:"Main gauche, rouge"},
  {sound:new Audio("/wav/main-gauche-en-lair.wav"), color: "#FFF", text:"Main gauche, en l’air"},
  {sound:new Audio("/wav/main-droite-vert.wav"), color: "#0F0", text:"Main droite, vert"},
  {sound:new Audio("/wav/main-droite-jaune.wav"), color: "yellow", text:"Main droite, jaune"},
  {sound:new Audio("/wav/main-droite-bleu.wav"), color: "#00F", text:"Main droite, bleu"},
  {sound:new Audio("/wav/main-droite-rouge.wav"), color: "#f00", text:"Main droite, rouge"},
  {sound:new Audio("/wav/main-droite-en-lair.wav"), color: "#FFF", text:"Main droite, en l’air"},
];

type RngAppState = {
  n: number
}

function getRandomInt(min:number, max:number): number {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

class Game extends Component<{}, RngAppState> {
  constructor(props: RngAppState) {
    super(props)
    let n = getRandomInt(0, id_mapping.length-1);
    this.state = {
      n: n
    };
    this.repeatHandler = this.repeatHandler.bind(this)
    this.refreshHandler = this.refreshHandler.bind(this)
  }
  refresh() {
    let n = getRandomInt(0, id_mapping.length-1)
    for(let i=0; i < id_mapping.length-1; i+=1){
      id_mapping[i].sound.pause();
    }
    
    this.setState({
      n: n
    });
    id_mapping[n].sound.currentTime = 0;
    id_mapping[n].sound.play();
  }

  repeatHandler(e: MouseEvent<HTMLButtonElement>) {
    for(let i=0; i < id_mapping.length-1; i+=1){
      id_mapping[i].sound.pause();
    }
    id_mapping[this.state.n].sound.currentTime = 0;
    id_mapping[this.state.n].sound.play();
    e.preventDefault();
  }

  refreshHandler(e: MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    this.refresh();
  }

  render () {
    let title, body;
    let c = "text-7xl sm:text-7xl lg:text-7xl leading-none font-extrabold tracking-tight text-gray-900 mt-10 mb-8 sm:mt-14 sm:mb-10";
    let c2 = "text-3xl sm:text-3xl lg:text-3xl leading-none font-extrabold tracking-tight text-gray-900 mt-10 mb-8 sm:mt-14 sm:mb-10";
    let m = id_mapping[this.state.n];
    title = <h1 className={c}>{m.text}</h1>
    body = <div className="grid grid-cols-2">
      <button className={c2} onClick={this.repeatHandler}>
        <FontAwesomeIcon icon={["fas", "clipboard"]} /> Répéter
      </button>
      <button className={c2} onClick={this.refreshHandler}>
        <FontAwesomeIcon icon={["fas", "sync"]} /> Un autre!
      </button>
    </div>

    return <div className="container mx-auto">
      <header className="flex justify-center">
        {title}
      </header>
      {body}
    </div>
  }
}

export default Game;
